import { Chips } from '@medtronic/pecc-react-component-library-js';
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import { NoticeBannerStatusEnum } from '~/api/types';
import { useDeleteNoticeBannerMutation, useGetNoticeBannersQuery } from '~/api/v2/hooks';
import { DeleteTypeEnum } from '~/components';
import { EditIcon, TrashIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';
import EmptyBanner from './EmptyBanner';

const NoticeBanner = () => {
  const dispatch = useAppDispatch();
  const { data, isFetching } = useGetNoticeBannersQuery({});
  const [deleteNoticeBanner] = useDeleteNoticeBannerMutation({});

  if (isFetching) return null;
  if (!data) return <EmptyBanner />;

  return (
    <Paper elevation={2} sx={{ p: 4, maxWidth: 524, minWidth: 300, minHeight: 300 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="headingS" mb="3rem" color="#0C0CA5">
            Notice Banner
          </Typography>
          <Box>
            <Chips
              alignment="left"
              chipsConfig={[
                {
                  label: capitalize(data?.status),
                  type: data?.status === NoticeBannerStatusEnum.ACTIVE ? 'confirm' : 'informative',
                },
              ]}
            />
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton
            size="large"
            sx={{ color: '#1010EB' }}
            onClick={() => {
              dispatch(
                openModal({
                  type: ModalTypesEnum.NOTICE_BANNER,
                  payload: { bannerData: data },
                }),
              );
            }}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="error"
            size="large"
            onClick={() => {
              dispatch(
                openModal({
                  type: ModalTypesEnum.DELETE_CONFIRMATION,
                  payload: {
                    type: DeleteTypeEnum.NOTICE_BANNER,
                    onDelete: () => {
                      deleteNoticeBanner({ bannerId: data?.id });
                    },
                  },
                }),
              );
            }}
          >
            <TrashIcon />
          </IconButton>
        </Stack>
      </Stack>
      <Typography variant="bodyLarge" sx={{ wordBreak: 'break-all' }}>
        {data?.message}
      </Typography>
    </Paper>
  );
};

export default NoticeBanner;
